import { ButtonPrimary } from '@/shared/ui/button';
import styles from './index.module.sass';
import partnerSvg from '../../images/partner.svg';
import { useNavigate } from 'react-router-dom';
import { useStore } from 'effector-react';
import {
  $buyersData,
  $buyersDataLoading,
  fetchBuyerByIdFx,
  fetchBuyersListFx,
  setActiveBuyer,
} from '@/modules/seller-account/store/buyers.store';
import { useEffect } from 'react';
import classNames from 'classnames';
import md5 from 'md5';
import { Spin, notification, Tooltip } from 'antd';
import settingsSvg from '@@/mixing/images/settings-icon.svg';
import { ButtonMain } from '@/modules/common/components/button';

export const BuyerWidget = ({ showBuyersFn }: IBuyerWidget) => {
  const navigate = useNavigate();
  const buyersListLoading = useStore($buyersDataLoading);
  useEffect(() => {
    fetchBuyersListFx({
      search: '',
    });
  }, []);
  const data = useStore($buyersData);
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <h3>Покупатели</h3>
        <a
          onClick={(e) => {
            e.preventDefault();
            navigate('/account/seller');
          }}
          className={styles.topButton}
        >
          <img src={settingsSvg} alt="управление" />
          управление
        </a>
      </div>
      {buyersListLoading.loading ? (
        <Spin className={styles.loader} size="large" />
      ) : Array.isArray(data?.data) && data?.data?.length > 0 ? (
        <>
          <ul className={styles.buyersList}>
            {data?.data?.map((item: any, i: number) => (
              <li
                key={i}
                className={styles.listItem}
                onClick={async () => {
                  try {
                    await fetchBuyerByIdFx({
                      id: item.id,
                      md5:
                        item.type === 'external' ? md5(item.company_name) : undefined,
                    });
                    setActiveBuyer(i);
                    navigate(`/account/seller?selected_buyer=${item.id}`);
                  } catch (err) {
                    notification.error({
                      message:
                        'Возникла непредвиденная ошибка. Попробуте, пожалуйста, позже',
                    });
                  }
                }}
              >
                <span className={styles.label}>
                  {' '}
                  <Tooltip
                    color={item.enabled ? '#66B28A' : '#7E89A5'}
                    title={
                      item.enabled
                        ? 'предложения покупателя учитываются при расчете системы'
                        : 'предложения покупателя не учитываются при расчете системы'
                    }
                    className={classNames(
                      styles.marker,
                      item.enabled && styles.markerActive,
                    )}
                  />{' '}
                  {item.company_name}
                </span>
                <span
                  className={classNames(
                    styles.type,
                    item.type === 'external' && styles.external,
                  )}
                >
                  {item.type === 'external' ? 'внешний контрагент' : 'ваш контрагент'}
                </span>
              </li>
            ))}
          </ul>
          { PUBLIC_MODE === 'development' && <ButtonMain
            className={styles.actionButton}
            onClick={() => navigate('/search')}
            label="показать предложения покупателей"
          />}
        </>
      ) : (
        <Placeholder />
      )}
    </div>
  );
};

interface IBuyerWidget {
  showBuyersFn: () => void;
}

var Placeholder = function () {
  const navigate = useNavigate();
  return (
    <div className={styles.content}>
      <img src={partnerSvg} alt="icon" />
      <div className={styles.contentBlock}>
        <span>
          Уже работаете с партнерами-
          <br />
          покупателями?
        </span>
        <p>
          Добавьте своих контрагентов
          <br /> и их предложения
        </p>
        <ButtonPrimary
          onClick={() => {
            navigate('/account/seller');
            setActiveBuyer(0);
          }}
          className={styles.mainButton}
          label={'добавить покупателя'}
        />
      </div>
    </div>
  );
};
